import { useAuth } from "react-oidc-context";
import { Navigate, Outlet } from "react-router";
import { routes } from "~/lib/constants";

export const PublicRoute = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to={routes.dashboard.taskManager} replace /> : <Outlet />;
};
